var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('link',{attrs:{"href":"https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta1/dist/css/bootstrap.min.css","rel":"stylesheet","integrity":"sha384-giJF6kkoqNQ00vy+HMDP7azOuL0xtbfIcaT9wjKHr8RbDVddVHyTfAAsrekwKmP1","crossorigin":"anonymous"}}),_c('PublicReply')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }